import { useState } from 'react'
import { Typography, Grid, IconButton } from '@material-ui/core/';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';
import { mixpanel } from '~/third_party/Mixpanel.jsx'

const DEFAULT_QUOTES = [
  {
    title: "“The service also stands out with a capability called 'restaurant bundling'.”",
    by: "Forbes",
    url: 'https://www.forbes.com/sites/annakang/2020/06/18/chinatown-wants-supporters-not-saviors/#330e8cd1517f'
  },
  {
    title: "“This is the Best Delivery Service You've Never Heard Of”",
    by: "Eat This Not That.",
    url: 'https://www.eatthis.com/delivery-service-chowbus/'
  },
  {
    title: "“The apps had to address safety concerns from all sides to ensure both couriers and customers were comfortable”",
    by: "Eater",
    url: 'https://ny.eater.com/2020/4/30/21241292/nyc-chinese-food-delivery-services-safety'
  },
]

const QuoteItem = props => {
  const { title, by, url } = props
  return <a style={{ textDecoration: 'none', color: 'inherit' }}
    onClick={
      () => mixpanel.track({
        name: "click news item",
        properties: {
          title,
          url
        }
      })
    } href={url}>
    <Grid container alignItems='center' spacing={4}>
      <Grid item xs={12}>
        <Typography paragraph variant='h5' align='center' style={{ fontFamily: 'proximanova-bold' }}>
          {title}
        </Typography>
        <Typography variant='body1' align='center' style={{ color: '#e00051' }}>
          by {by}
        </Typography>
      </Grid>
    </Grid>
  </a>
}

const Quotes = props => {
  const { quotes = DEFAULT_QUOTES } = props
  const [quoteIndex, setQuoteIndex] = useState(0)
  const previous = () => {
    const index = quoteIndex - 1
    mixpanel.track({
      name: "click previous news item"
    })
    setQuoteIndex(index < 0 ? quotes.length - 1 : index)
  }

  const next = () => {
    const index = quoteIndex + 1
    mixpanel.track({
      name: "click next news item"
    })
    setQuoteIndex(index >= quotes.length ? 0 : index)
  }

  return <Grid container justify='center' alignItems='center'>
    <Grid container item xs={2} alignItems='center' justify='center'>
      <IconButton onClick={previous}>
        <ArrowLeft style={{ width: 84, height: 84, color: '#ffffff' }} />
      </IconButton>
    </Grid>
    <Grid item xs={8}>
      <QuoteItem {...quotes[quoteIndex]} />
    </Grid>
    <Grid container item xs={2} alignItems='center' justify='center'>
      <IconButton onClick={next}>
        <ArrowRight style={{ width: 84, height: 84, color: '#ffffff' }} />
      </IconButton>
    </Grid>
  </Grid>
}

export default Quotes